import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import AppColors from 'general/constants/AppColors';
import KTBSButton, {
  KTBSButtonColor,
  KTBSButtonSize,
} from 'general/components/OtherKeenComponents/KTBSButton';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import ToastHelper from 'general/helpers/ToastHelper';
import moment from 'moment';

ViewRegisterInvestmentPackage.propTypes = {
  onClosed: PropTypes.func,
  onSubmitted: PropTypes.func,
  packageList: PropTypes.array,
};

function ViewRegisterInvestmentPackage(props) {
  // MARK: ---- params ----
  const { t } = useTranslation();
  const { onClosed, onSubmitted, packageList } = props;
  const [selectedPackageId, setSelectedPackageId] = useState();

  return (
    <div
      style={{
        backgroundColor: AppColors.gray[100],
      }}
    >
      <div className="p-4">
        <div className="row m-0">
          {packageList?.map((row, index) => {
            return (
              <div key={`package_item_${row?.packageId}`} className="col-6 p-0">
                <div
                  className="p-6 m-2 d-flex flex-column cursor-pointer hover-opacity-80"
                  onClick={() => {
                    setSelectedPackageId(row?.packageId);
                  }}
                  style={{
                    border: `1px solid ${
                      selectedPackageId == row?.packageId ? AppColors.primary : AppColors.gray[300]
                    }`,
                    backgroundColor:
                      selectedPackageId == row?.packageId ? 'rgba(243, 255, 238, 1)' : 'white',
                  }}
                >
                  <span
                    style={{
                      color: AppColors.gray[800],
                      fontWeight: '600',
                      fontSize: Utils.convertToFontSize(16),
                    }}
                  >
                    {row?.name}
                  </span>
                  <span
                    style={{
                      color: AppColors.gray[600],
                      fontWeight: '700',
                      fontSize: Utils.convertToFontSize(26),
                    }}
                  >
                    {Utils.formatNumber(row?.amount ?? 0)} {row?.currency}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="d-flex align-items-center gap-3 justify-content-end bg-white p-6 border-top">
        <KTBSButton
          color={KTBSButtonColor.secondary}
          title={t('cancel')}
          size={KTBSButtonSize.large}
          borderRadius={5}
          buttonTitleFontWeight="600"
          onPress={onClosed}
          buttonTitleColor={'rgba(74, 86, 119, 1)'}
          // additionalClassName="w-100"
        />
        <KTBSButton
          color={KTBSButtonColor.success}
          title={t('Đăng ký gói')}
          size={KTBSButtonSize.large}
          borderRadius={5}
          buttonTitleFontWeight="600"
          onPress={() => {
            if (_.isUndefined(selectedPackageId)) {
              ToastHelper.showError('Bạn chưa chọn gói đầu tư');
              return;
            }
            const investmentPackage = _.find(
              packageList,
              (row) => row?.packageId == selectedPackageId
            );
            if (onSubmitted) {
              onSubmitted({
                date: moment().format('YYYY-MM-DD'),
                packageId: selectedPackageId,
                investmentPackage,
              });
            }
          }}
          // additionalClassName="w-100"
        />
      </div>
    </div>
  );
}

export default ViewRegisterInvestmentPackage;
